// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Main from './components/Main';
import Cover from './components/Cover';
import 'bootstrap/dist/css/bootstrap.min.css';
import BackgroundMusic from './components/Music';
import LinkGenerator from './components/LinkGenerator'; // ✅ add this import


const AnimatedRoutes = () => {
  const location = useLocation();

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        {/* ✅ New route for generator page */}
        <Route path="/generate" element={<LinkGenerator />} />

        {/* Default redirect if no name provided */}
        <Route path="/" element={<Navigate to="/ភ្ញៀវកិត្តិយស" replace />} />
        
        {/* Personalized cover page with guest name */}
        <Route path="/:guestName" element={<Cover />} />

        {/* Main invitation page */}
        <Route path="/main" element={<Main />} />
      </Routes>
    </AnimatePresence>
  );
};

function App() {
  return (
    <Router>
      <BackgroundMusic/>
      <AnimatedRoutes />
    </Router>
  );
}

export default App;
